import { MagnifyingGlassIcon } from '../../assets/images/components';
import './UnsuccessfulSearch.scss';

const UnsuccessfulSearch = ({
  paddingTop,
  customText,
  hideIcon,
  customClassName = '',
  customTextClassName = '',
  customContainerIconClassName = '',
  iconSize = 48
}: {
  paddingTop?: number;
  customText?: string;
  hideIcon?: boolean;
  customClassName?: string;
  customTextClassName?: string;
  customContainerIconClassName?: string;
  iconSize?: number;
}) => {
  const paddingTopStyles = { paddingTop: `${paddingTop ?? 136}px` };
  const defaultText = 'No hay resultados para tu búsqueda';
  const iconSizeStyle = `${iconSize}px`;

  return (
    <div className={`unsuccessfulSearch ${customClassName}`} style={paddingTopStyles}>
      {!hideIcon && (
        <div className={`magnifierIconContainer ${customContainerIconClassName}`}>
          <img
            src={MagnifyingGlassIcon}
            alt="Lupa"
            className="unsuccessfulSearchIcon"
            style={{ width: iconSizeStyle, height: iconSizeStyle }}
          />
        </div>
      )}
      <div className={`text ${customTextClassName}`}>{customText || defaultText}</div>
    </div>
  );
};

export default UnsuccessfulSearch;
